import { Button, Card, Icons, Stack } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { MedicationChangeComparison } from '../../components/therapy/MedicationChangeComparison.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryMedicationChange({ history, patient }: { history: HistoryDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  return (
    <HistoryEntry history={history} subject={'Die Medikation von'} action={'wurde geändert von'} patient={patient}>
      <Card>
        <Stack direction={'row'} justifyContent={'space-between'} gap={5}>
          <Stack>
            {history.medicationChange && <MedicationChangeComparison medicationChange={history.medicationChange} />}
          </Stack>
          <Stack alignItems={'start'}>
            <Button
              endDecorator={<Icons.ArrowForward />}
              onClick={() =>
                navigate({ to: '/patients/$patientId/therapy', params: { patientId: history.patientId } })
              }>
              Zur Therapie
            </Button>
          </Stack>
        </Stack>
      </Card>
    </HistoryEntry>
  );
}
